import React from "react";
import { Modal, Button } from "react-bootstrap";

const LeaveDetailModal = ({ show, onHide, leaveRestriction }) => {
  if (!leaveRestriction) return null;

  return (
    <Modal show={show} onHide={onHide}>
      <Modal.Header closeButton>
        <Modal.Title>Leave Restriction Details</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p>
          <strong>Staff Type:</strong>{" "}
          {leaveRestriction.id_generalStaffType
            ? leaveRestriction.id_generalStaffType.name
            : "N/A"}
        </p>
        <p>
          <strong>Client:</strong>{" "}
          {leaveRestriction.id_client ? leaveRestriction.id_client.name : "N/A"}
        </p>
        <p>
          <strong>Casual Leave Balance:</strong>{" "}
          {leaveRestriction.casualLeaveBalance !== null
            ? leaveRestriction.casualLeaveBalance
            : "N/A"}
        </p>
        <p>
          <strong>WFH Balance:</strong>{" "}
          {leaveRestriction.wfhBalance !== null
            ? leaveRestriction.wfhBalance
            : "N/A"}
        </p>
        <p>
          <strong>Weekend Policy:</strong>{" "}
          {leaveRestriction.weekendPolicy || "N/A"}
        </p>
        <p>
          <strong>Holiday Restrictions:</strong>{" "}
          {Array.isArray(leaveRestriction.holidayRestrictions) &&
          leaveRestriction.holidayRestrictions.length > 0
            ? leaveRestriction.holidayRestrictions.join(", ")
            : "None"}
        </p>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onHide}>
          Close
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default LeaveDetailModal;
